<template>
  <el-form>
    <el-form-item>
      <el-input
        ref="input"
        :value="url"
        readonly
        @focus="(evt) => evt.target.select()"
      />
      <el-tooltip
        content="Copier le lien vers la liste cadeau"
        placement="top"
      >
        <el-button
          v-clipboard:copy="url"
          v-clipboard:success="() => {
            $refs.input.select()
            $emit('copy')
          }"
          :type="buttonIsPrimary ? 'primary' : null"
        >
          Copier
        </el-button>
      </el-tooltip>
    </el-form-item>
  </el-form>
</template>

<script>
import WEBSITE_URLS from '@/services/website-target'

export default {
  props: {
    id: {
      type: String,
      required: true
    },
    buttonIsPrimary: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  computed: {
    url () {
      return `${WEBSITE_URLS.giftlist}?id=${this.id}`
    }
  }
}
</script>

<style lang="scss" scoped>
    .el-input {
      width: auto;
      flex-grow: 1;

      margin-right: 1rem;
    }
</style>
